import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { FiCreditCard, FiDownload, FiEye, FiEyeOff } from "react-icons/fi";
import MonthDisplay from "./Months";
import { get_file_from_s3 } from "../utils";
import TileShell from "./DashboardTiles/TileShell";
import { MASKED_AMOUNT } from "./PayslipAmountToggle";

const PaySlipEmployee = ({ isError, className = "" }) => {
  const [showSalary, setShowSalary] = useState(false);
  const navigate = useNavigate();
  const { paySlipData } = useSelector((state) => state.payroll);

  const toggleSalaryVisibility = () => {
    setShowSalary(!showSalary);
  };

  const handleDownload = async (file) => {
    try {
      const res = await get_file_from_s3(file?.fileName);
      const s3Url = res;
      if (!s3Url) {
        toast.error("Failed to fetch the file");
        return;
      }

      const response = await fetch(s3Url);
      const blob = await response.blob();
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      const urlParts = s3Url.split("/");
      const fullFileName = urlParts[urlParts.length - 1]; //need to change as per filename
      const [filename] = fullFileName.split("?");
      downloadLink.setAttribute("download", filename);
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const hasPayslip = Object.keys(paySlipData?.data || {}).length !== 0;

  const amounts = [
    { label: "Gross Pay", value: paySlipData?.data?.totalGrossPay },
    { label: "Deduction", value: paySlipData?.data?.totalDeduction },
    { label: "Net Pay", value: paySlipData?.data?.totalNetPay },
  ];

  return (
    <TileShell
      icon={FiCreditCard}
      title="PaySlip"
      actionLabel="View all"
      onAction={() => navigate("/payslip")}
      className={className}
      bodyClassName="flex flex-col"
    >
      {!hasPayslip ? (
        <p className="text-sm text-gray-500">
          {paySlipData?.message ?? "No results found"}
        </p>
      ) : (
        <>
          <p className="text-sm font-semibold text-blue-600">
            <MonthDisplay monthNumber={paySlipData?.data?.payrollMonth} />{" "}
            {paySlipData?.data?.payrollYear}
          </p>

          <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
            {amounts.map((row) => (
              <div
                key={row.label}
                className="min-w-0 rounded-xl bg-gray-50 px-3 py-2.5"
              >
                <p className="text-xs font-medium text-gray-500">{row.label}</p>
                <p className="truncate text-lg font-bold text-gray-900">
                  {showSalary ? `₹${row.value ?? "-"}` : MASKED_AMOUNT}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-4 flex flex-wrap items-center gap-2">
            <button
              type="button"
              className="inline-flex items-center gap-1.5 rounded-lg bg-blue-50 px-3 py-1.5 text-xs font-semibold text-blue-600 transition hover:bg-blue-100"
              onClick={() =>
                handleDownload(paySlipData?.data?.paySlipDetails?.s3Document)
              }
            >
              <FiDownload size={13} />
              Download
            </button>
            <button
              type="button"
              className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold text-gray-600 transition hover:bg-gray-100"
              onClick={toggleSalaryVisibility}
            >
              {showSalary ? <FiEyeOff size={13} /> : <FiEye size={13} />}
              {showSalary ? "Hide Salary" : "Show Salary"}
            </button>
          </div>
        </>
      )}
    </TileShell>
  );
};

export default PaySlipEmployee;
